export const GOOGLE_PLACES_FIELDS = {
  ADDRESS_COMPONENTS: 'addressComponents',
  LOCATION: 'location',
  FORMATTED_ADDRESS: 'formattedAddress',
  ID: 'id',
  NAME: 'displayName',
  FORMATTED_PHONE_NUMBER: 'nationalPhoneNumber',
  WEBSITE: 'websiteURI',
};

export const GOOGLE_PLACES_ADDRESS_COMPONENTS = {
  STREET_NUMBER: 'street_number',
  ROUTE: 'route',
  LOCALITY: 'locality',
  POSTAL_TOWN: 'postal_town',
  ADMINISTRATIVE_AREA_LEVEL_3: 'administrative_area_level_3',
  ADMINISTRATIVE_AREA_LEVEL_1: 'administrative_area_level_1',
  POSTAL_CODE: 'postal_code',
  COUNTRY: 'country',
};

export const GOOGLE_PLACES_FIELDS_LIST = [
  GOOGLE_PLACES_FIELDS.ID,
  GOOGLE_PLACES_FIELDS.NAME,
  GOOGLE_PLACES_FIELDS.FORMATTED_PHONE_NUMBER,
  GOOGLE_PLACES_FIELDS.WEBSITE,
  GOOGLE_PLACES_FIELDS.FORMATTED_ADDRESS,
  GOOGLE_PLACES_FIELDS.ADDRESS_COMPONENTS,
  GOOGLE_PLACES_FIELDS.LOCATION,
];
